import React from "react";

const Alert = ({title,message,color,callback}) => {  
  return (
    <>
        <div
          className={"text-white px-6 py-4 border-0 rounded relative mb-4 "+color}
        >
          <span className="inline-block align-middle mr-8">
            <b className="capitalize">{title}</b>{message}
          </span>
          <button
            className="absolute bg-transparent text-2xl font-semibold leading-none right-0 top-0 mt-4 mr-6 outline-none focus:outline-none"
            onClick={() => callback()}
          >
            <span>×</span>
          </button>
        </div>
    </>
  );
};

Alert.defaultProps = {
    title: "",
    message: "",
    color: "bg-green-500"
}

export default Alert;